/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOdometerMid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 16C2 10.477 6.477 6 12 6s10 4.477 10 10h-2a8 8 0 1 0-16 0zm9-3.33a3.001 3.001 0 1 0 2 0V10h-2zm1 1.83a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOdometerMid as OdometerMid };
